import { useState, useEffect } from 'react';

/**
 * Hook to manage tooltip visibility based on scroll position in notes modal
 * Tooltips should only show when the modal is not being scrolled
 */
const useNotesModalScroll = () => {
  const [showTooltip, setShowTooltip] = useState(true);
  const [isScrolling, setIsScrolling] = useState(false);

  const handleScroll = () => {
    if (!isScrolling) {
      setIsScrolling(true);
      setShowTooltip(false);
    }

    // Clear any existing timeout
    if (window.scrollTimeout) {
      clearTimeout(window.scrollTimeout);
    }

    // Set a timeout to re-enable tooltips after scrolling stops
    window.scrollTimeout = setTimeout(() => {
      setIsScrolling(false);
      setShowTooltip(true);
    }, 150);
  };

  useEffect(() => {
    // Cleanup timeout on unmount
    return () => {
      if (window.scrollTimeout) {
        clearTimeout(window.scrollTimeout);
      }
    };
  }, []);

  return { showTooltip, handleScroll };
};

export default useNotesModalScroll;

